import { observer } from 'mobx-react'
import React from 'react'

import { EMPTY_STRING } from '@flowwai-frontend/shared/constants'
import { UserModel } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import UserDetails from '../../components/UserDetails/UserDetails'

interface Props {
   userDetails: UserModel
}

const UserDetailsController = (props: Props): React.ReactElement => {
   const { userDetails } = props

   // NOTE: Handle User Details Update APIs here

   return (
      <UserDetails
         name={userDetails.name ?? EMPTY_STRING}
         phoneNumber={userDetails.phoneNumber?.phoneNumber ?? EMPTY_STRING}
         profilePicUrl={userDetails.profilePicUrl}
      />
   )
}

export default observer(UserDetailsController)
